export interface NavItem {
  label: string
  to: string
  adminOnly?: boolean
}

export const MAIN_NAV: readonly NavItem[] = [
  { label: 'Chat', to: '/chat' },
  { label: 'Agent Orchestration', to: '/' },
  { label: 'Audit Trail', to: '/audit-trail' },
  { label: 'Configuration', to: '/configuration' },
  { label: 'Users', to: '/users', adminOnly: true },
  { label: 'Profile', to: '/profile' },
]
